<template>
  <v-app id="inspire" v-if="load">
    <v-main>
      <v-container class="fill-height pa-0"
                   fluid
                   :style="`background-image: url('${backgroundImage}'); background-position: center center; background-size: cover;`">
      <v-col offset-sm="1" sm="10">
        <v-row>
          <v-col sm="10" md="8" lg="4" xl="3" class="fill-height" align="center" style="background-color: #FFFFFFCA">
            <v-row align="center" class="fill-height">
              <v-col>
                <v-avatar size="250" max-height="100px" tile>
                  <v-img :src="logoImage" height="100%" contain />
                </v-avatar>
                <core-form class="mt-4" :submit="login">
                    <v-col>
                      <input-email  label="E-mail" v-model="credentials.email" autofocus placeholder=" " />
                    </v-col>
                    <v-col class="pb-1 pt-2">
                      <input-password
                        label="Senha"
                        v-model="credentials.password"
                      />
                    </v-col>
                    <v-col class="pt-0 pb-10">
                      <router-link to="/lembrar"
                                   class="float-right font-weight-medium caption text-decoration-none">Esqueceu a senha?</router-link>
                      <v-btn type="submit"
                             class="float-left"
                             :disabled="!credentials.email || !credentials.password"
                             color="primary">
                        Entrar
                      </v-btn>
                      <v-alert v-show="error"
                               type="error"
                               class="mt-3"
                               text
                               icon="error">
                        {{ error }}
                      </v-alert>
                    </v-col>
                </core-form>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      </v-container>
      <core-login-error ref="loginError" @follow="followLogin"/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: this.tabTitle + ' - Login',
    }
  },
  data () {
    return {
      load: false,
      ambiente: localStorage.ambiente,
      credentials: {
      },
      error: '',
      logoImage: this.$theme.logo || '/assets/imgs/logo.svg',
      backgroundImage: this.$theme.background || '/assets/imgs/background.svg',
      tabTitle: window.env.VUE_APP_NOME
    }
  },
  methods: {
    login () {
      const th = this;
      th.$api.Autenticacao.Autenticar(th.credentials)
        .then(function (data) {
          if (data.errorCode) {
            th.$refs.loginError.openModal(data);
          } else if (th.$api.UI.PostLoadData(data, true)) {
            th.setUser(data)
          }
        })
        .catch((err) => console.log(err));
    },
    followLogin (data) {
      const th = this;
      th.setUser(data);
    },
    setUser (authResponse) {
      const th = this;
      const user = th.$api.UTIL.Auth.RegisterToken(authResponse);
      if (user) {
        th.$store.dispatch('setUserData', { user }).then(() => {
          th.$router.push({
            path: '/parceiro',
          });
        });
      }
    },
    getPortal () {
      const th = this
      th.$api.Multiplo.GetPortalByAmbiente(localStorage.ambiente).then((response) => {
        th.tabTitle = response
      })
    }
  },
  beforeMount () {
    const th = this
    if (localStorage.ambiente) {
      th.$api.Empresa.GetByAmbiente(localStorage.ambiente).then(function (response) {
        if (!response || response.ambiente === null || response.customizacao !== process.env.VUE_APP_CUSTOMIZACAO) {
          th.$router.push('/partner-not-found')
        } else {
          th.getPortal()
          th.load = true
        }
      })
    } else {
      if (location.origin.indexOf('nellpay.multiplo') >= 0) {
        location.href = '/partner/nellpay'
      } else {
        location.href = '/partner-not-informed'
      }
    }
  }
}
</script>
